export default "__VITE_ASSET__TcRk$32r__"